<template>
  <div>
    <Breadcrumb msg1="会员管理" msg2="会员列表" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6"><el-input v-model="query.keyword" placeholder="姓名/手机号" clearable></el-input></el-col>
        <el-col :span="5">
          <el-select v-model="query.level_id" placeholder="等级" clearable>
            <el-option v-for="l in levels" :key="l.id" :label="l.name" :value="l.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="正常" value="正常"></el-option>
            <el-option label="冻结" value="冻结"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="openCard">开卡</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" width="60"><template slot-scope="scope">{{ scope.row.member.id }}</template></el-table-column>
        <el-table-column label="客户" width="110"><template slot-scope="scope">{{ scope.row.customer ? scope.row.customer.name : '' }}</template></el-table-column>
        <el-table-column label="手机号" width="130"><template slot-scope="scope">{{ scope.row.customer ? scope.row.customer.phone : '' }}</template></el-table-column>
        <el-table-column label="等级" width="100"><template slot-scope="scope">{{ scope.row.level ? scope.row.level.name : '' }}</template></el-table-column>
        <el-table-column label="余额" width="100"><template slot-scope="scope">{{ scope.row.member.balance }}</template></el-table-column>
        <el-table-column label="积分" width="90"><template slot-scope="scope">{{ scope.row.member.points }}</template></el-table-column>
        <el-table-column label="累计储值" width="100"><template slot-scope="scope">{{ scope.row.member.totalRecharge }}</template></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.member.status === '冻结' ? 'danger' : 'success'">{{ scope.row.member.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="view(scope.row.member.id)">详情</el-button>
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="500px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="客户" required v-if="!form.id">
          <el-select v-model="form.customer_id" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="等级">
          <el-select v-model="form.level_id" style="width: 100%">
            <el-option v-for="l in levels" :key="l.id" :label="l.name" :value="l.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="初始余额" v-if="!form.id"><el-input v-model.number="form.balance" type="number"></el-input></el-form-item>
        <el-form-item label="状态" v-if="form.id">
          <el-select v-model="form.status" style="width: 100%">
            <el-option label="正常" value="正常"></el-option>
            <el-option label="冻结" value="冻结"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, keyword: '', level_id: null, status: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {},
      levels: [],
      customerOptions: []
    }
  },
  created () {
    this.getData()
    this.$axios.http.get('/memberLevels').then(r => { if (r.data.status === 200) this.levels = r.data.data || [] })
  },
  methods: {
    getData () {
      this.$axios.get('/members', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    openCard () {
      this.dialogTitle = '会员开卡'
      this.form = { customer_id: null, level_id: null, balance: 0 }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑会员'
      this.form = { id: row.member.id, level_id: row.member.levelId, status: row.member.status }
      this.show = true
    },
    save () {
      if (this.form.id) {
        this.$axios.put(`/members/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        if (!this.form.customer_id) { this.$message.warning('请选择客户'); return }
        this.$axios.post('/members', () => { this.show = false; this.getData() }, this.form)
      }
    },
    view (id) {
      this.$router.push(`/member/detail/${id}`)
    }
  }
}
</script>
